import React from "react";

const AutoCompleteItem = ({ name, onSelectItem, isHighlighted }) => {
  return (
    <li
      className={`list-group-item list-group-item-action d-flex align-items-center justify-content-between px-3 py-2 ${
        isHighlighted ? "bg-primary text-white" : ""
      }`}
      style={{
        cursor: "pointer",
        transition: "all 0.15s ease",
        fontSize: "0.92rem",
        borderLeft: isHighlighted ? "4px solid #0bb6d7" : "4px solid transparent"
      }}
      onClick={onSelectItem}
    >
      <div className="d-flex align-items-center gap-2">
        <i
          className={`bi bi-bookmark-fill ${isHighlighted ? 'text-white' : 'text-primary'}`}
          style={{ fontSize: '0.85rem' }}
        ></i>
        <span className={isHighlighted ? "fw-bold text-white" : "fw-medium text-dark"}>
          {name}
        </span>
      </div>
      <span className={`badge ${isHighlighted ? 'bg-white text-primary' : 'bg-light text-muted border'} small`}>
        Select
      </span>
    </li>
  );
};

export default AutoCompleteItem;